import { jsxs as y, jsx as a } from "react/jsx-runtime";
import { c as v } from "../../../index-Cu0xwYjD.js";
import { forwardRef as u } from "react";
import { Icon as m } from "../Icon/Icon.js";
import { s as r } from "../../../CTAButton.module-ll2XoNNI.js";
const $ = u(
  ({
    variant: e = "primary",
    fullWidth: s,
    iconRight: t = "off",
    iconLeft: c = "off",
    inverted: f = !1,
    children: l,
    className: d,
    ...i
  }, p) => {
    const o = `--el-component-cta-${e}`;
    return /* @__PURE__ */ y(
      "button",
      {
        ref: p,
        type: "button",
        style: {
          "--background-color": `var(${o}-surface)`,
          "--color": `var(${o}-message)`,
          "--outline-focused": `var(${o}-outline-focused)`,
          "--path": `var(${o}-message)`,
          "--surface-hover": `var(${o}-surface-hover)`,
          "--message-hover": `var(${o}-message-hover)`
        },
        className: v(
          r.button,
          {
            [r.secondary]: e === "secondary",
            [r.inverted]: f,
            [r.secondaryWidth]: s && e === "secondary",
            [r.fullWidth]: s
          },
          d
        ),
        ...i,
        children: [
          c !== "off" ? /* @__PURE__ */ a(m, { name: c, size: 16 }) : null,
          /* @__PURE__ */ a("span", { children: l }),
          t !== "off" ? /* @__PURE__ */ a(m, { name: t, size: 16 }) : null
        ]
      }
    );
  }
), n = (e) => u((s, t) => /* @__PURE__ */ a($, { variant: e, ref: t, ...s })), b = n("primary"), g = n("secondary"), x = n("destructive");
export {
  $ as CTAButton,
  x as DestructiveCTAButton,
  b as PrimaryCTAButton,
  g as SecondaryCTAButton
};
